import { defineComponent, computed } from 'vue';
import { Helper } from '@hems/util';
export default defineComponent({
    name: 'ApplianceCurrentValueBox',
    props: {
        data: {
            type: Object,
            required: true,
        },
        applianceComponentType: {
            type: String,
            default: 'main',
        },
    },
    setup(props) {
        const applianceCurrentValueData = computed(() => props.data);
        const applianceComponentTypeData = computed(() => props.applianceComponentType);
        return {
            applianceCurrentValueData,
            applianceComponentTypeData,
            formatNumber: Helper.formatNumber,
        };
    },
});
